module.exports = __webpack_public_path__ + "img/logo.0f9047a9.png";